<template>
  <div class="mt-[16px] mb-[16px]">
    <div v-if="isLoading">
      <USkeleton
        class="w-[164px] h-[20px]"
        :ui="{
          base: 'animate-pulse round-[8px] bg-[#DEDEDE]',
        }"
        data-testid="sub-header-title-skeleton"
      />
    </div>
    <div
      v-else
      class="text-[14px] md:text-[16px] font-[500] text-[#292828] leading-[20px] md:leading-[24px] text-left"
      data-testid="sub-header-title-text"
    >
      บทความ
    </div>
  </div>
</template>
<script setup lang="ts">
defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
});
</script>
